import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "_flexcol" }
const _hoisted_2 = {
  key: 0,
  class: "_tc--lighter _flexcntr _mt-3"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_themed_image = _resolveComponent("themed-image")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.availableProviders, (provider) => {
      return (_openBlock(), _createBlock(_component_base_button, {
        key: provider.name,
        disabled: !provider.isClickable,
        class: "gfu-btn-signing _flexbtwn _ai-c",
        onClick: $event => ($options.onSignIn(provider.instance, provider.type))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_themed_image, {
            src: provider.imageUrl,
            alt: "Provider logo",
            width: "24",
            height: "24"
          }, null, 8 /* PROPS */, ["src"]),
          _createTextVNode(" " + _toDisplayString(_ctx.Resources.format(_ctx.Resources.Account.ExternalLoginProviderChoiceButton, provider.name)) + " ", 1 /* TEXT */),
          _createVNode(_component_base_icon, {
            name: "chevron-right",
            class: "_tc--accent"
          })
        ]),
        _: 2 /* DYNAMIC */
      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled", "onClick"]))
    }), 128 /* KEYED_FRAGMENT */)),
    ($options.availableProviders.length > 0)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString($options.messageViewType), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_progress_overlay, { visible: _ctx.isProcessing }, null, 8 /* PROPS */, ["visible"])
  ]))
}